import { createStyles } from '@mui/styles';
import COLORS from '../../styles/Colors';

const styles = createStyles({
  button: {
    width: '100%',
    height: 40,
    borderRadius: 25,
    border: `1px solid ${COLORS.INACTIVE_LIGHT}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    fontSize: 14,
    backgroundColor: COLORS.WHITE,
    cursor: 'pointer',
    gap: 10,
    fontFamily: 'Roboto, sans-serif',
    marginTop: '20px',
  },
  icon: {
    width: 18,
    height: 18,
  },
});

export default styles;
